import React from "react";
import { Helmet } from "react-helmet";
import { Card, CardBody } from "reactstrap";
import { useHistory } from "react-router-dom";

import HeaderWithBackButton from "../../components/HeaderWithBackButton/HeaderWithBackButton";
import { APP_ROUTES } from "../../helpers/routeHelpers";

import NotificationForm from "./NotificationForm";
import { useRequestProcessor } from "../../hooks/useRequestProcessors";
import { CreateNotification } from "../../api/api.service";
import { getKey } from "../../api/api.keys";
import SubscriptionStatus, { SUBSCRIPTION_STATUS } from "../../constants/SubscriptionStatus";
import { formatScheduledAt } from "../../utils/dateUtils";
import { NoticationType } from "../../constants";
import { NOTIFICATION_TYPE } from "../../constants/NoticationType";
import { showToast, SUCCESS } from "../../utils/toastUtils";

const AddNotification = () => {
    const history = useHistory();

    let { useMutate } = useRequestProcessor();
    let { mutate, isLoading } = useMutate("", getKey(), (data) => CreateNotification(data));

    const addNotificationHandler = (values) => {
        try {
            const bodyData = {
                title: values.title,
                content: values.notificationMessage,
                type:
                    values.notificationType ==
                    NoticationType.getDisplayTextKey(NOTIFICATION_TYPE.PROMOTION)
                        ? NOTIFICATION_TYPE.PROMOTION
                        : NOTIFICATION_TYPE.RECOMMENDATION,
                tierType:
                    values.userGroup ===
                    SubscriptionStatus.getDisplayTextKey(SUBSCRIPTION_STATUS.FREEMIUM)
                        ? SUBSCRIPTION_STATUS.FREEMIUM
                        : values.userGroup ===
                          SubscriptionStatus.getDisplayTextKey(SUBSCRIPTION_STATUS.PREMIUM)
                        ? SUBSCRIPTION_STATUS.PREMIUM
                        : SUBSCRIPTION_STATUS.ALL,
                scheduledAt: formatScheduledAt(values.scheduleDate, values.scheduleTime),
                ageBracketIds: values.ageGroup?.map((ageGroup) => ageGroup.value) || []
            };

            mutate(bodyData, {
                onSuccess: async (res) => {
                    showToast(SUCCESS, "Notification created successfully");
                    history.push(APP_ROUTES.NOTIFICATION_MANAGEMENT);
                },
                onError: (err) => {
                    console.log("not cerated", err);
                }
            });
        } catch (error) {
            console.error("Error during form submission:", error);
        }
    };

    const handleBackClick = () => {
        history.push(APP_ROUTES.NOTIFICATION_MANAGEMENT);
    };

    return (
        <div className="page-content">
            <Helmet>
                <title>User Management Details</title>
            </Helmet>
            <HeaderWithBackButton title="Add Notification" onBackClick={handleBackClick} />
            <Card className="" style={{ borderRadius: "20px" }}>
                <CardBody>
                    <NotificationForm
                        mode="add"
                        isLoading={isLoading}
                        onAddNotification={addNotificationHandler}
                        isDisabled={isLoading}
                    />
                </CardBody>
            </Card>
        </div>
    );
};

export default AddNotification;
